import React from 'react';
import { Eventcalendar, localeNo } from "@mobiscroll/react";
import { query, collection, database, where, getDocs } from '../Utils/firebaseConfig';
import useCalendarData from '../Hooks/useFetchResources';
import { getEventWriteCollection } from '../Utils/eventCollections';
import './Agenda.css'
import "@mobiscroll/react/dist/css/mobiscroll.react.min.css";

import { useAuth } from '../Hooks/useAuth';
import isElectron from '../Utils/isElectron';



const Agenda = () => {

  const { user, userSettings } = useAuth()
  //CUSTOM CODE
  const eventDatabase = getEventWriteCollection()
  
  const [myEvents, setEvents] = React.useState([]);
  const { resources} = useCalendarData(myEvents, new Date());
  const [eventContent, setEventContent] = React.useState([]);

  // STANDARD:
  const [currentEvent, setCurrentEvent] = React.useState(null);
  const [equipment, setEquipment] = React.useState([]);
  // const [time, setTime] = React.useState('');
  // const [status, setStatus] = React.useState('');
  // const [reason, setReason] = React.useState('');
  // const [location, setLocation] = React.useState('');
  // const [buttonText, setButtonText] = React.useState('');
  // const [buttonType, setButtonType] = React.useState('');
  // const [bgColor, setBgColor] = React.useState('');
  const hasSetupRef = React.useRef(false);

  // CUSTOM CODE




  const flattenArr = React.useCallback((arr, flat = []) => {
    for (let i = 0; i < arr.length; i++) {
      flat.push(arr[i]);
      if (arr[i].children && arr[i].children.length) {
        flat.pop() // remove headers from list
        flattenArr(arr[i].children, flat);
      }
    }
    return flat;
  }, []);

  React.useEffect(() => {
    if (isElectron()) {
      if (hasSetupRef.current) return;
      hasSetupRef.current = true;
      // --- ELECTRON: Subscribe to real-time events from main process ---
      console.log('[Agenda] Electron detected, setting up real-time event listener (main process relay)');
      const collection = eventDatabase;
      // For demo, use a wide date range; in production, use actual calendar range
      const start = new Date(2000, 0, 1).toISOString();
      const end = new Date(2100, 0, 1).toISOString();
      window.electronAPI.startEventsListener(collection, start, end);
      const handler = (events) => {
        console.log('[Agenda] Received events-update from Electron (main process):', events);
        setEvents(events);
      };
      window.electronAPI.onEventsUpdate(handler);
      return () => {
        // No unsubscribe API yet; could be added if needed
      };
    } else {
      // Only proceed once user and resources are ready in web mode
      if (!user?.email || !resources?.length) return;

      const handleResourceCheckInEvent = (email) => {
        flattenArr(resources).forEach((item) => {
          if (item.email === email) {
            getUserEvents(item.id);
          }
        });
      };

      const getUserEvents = async (id) => {
        const userRef = collection(database, eventDatabase);
        const q = query(userRef, where('resource', 'array-contains', id));
        const querySnapshot = await getDocs(q);
        let events = [];
        querySnapshot.forEach((doc) => {
          events.push({
            ...doc.data(),
            start: doc.data().start.toDate(),
            end: doc.data().end.toDate()
          });
        });
        setEvents(events);
      }

      handleResourceCheckInEvent(user.email)
    }
  }, [resources, user?.email, eventDatabase, flattenArr]);




  const onEventClick = React.useCallback((args) => {
    const event = args.event;



    const resourcesInEvent = []
    args.event.resource.forEach(element => {
      flattenArr(resources).forEach((obj) => {
        if (obj.id === element) {
          resourcesInEvent.push(obj)
        }
      });
    })
    resourcesInEvent.sort(function (a, b) {
      return (a.id - b.id) || a.name.localeCompare(b.name);
    });
    setEventContent([...resourcesInEvent])


    setCurrentEvent(event);


    setEquipment([args.event.resource])
    // setOpen(true);
  }, [flattenArr, resources]);

  // const onEventClick = React.useCallback(() => {
  //   setOpen(true);
  // }, []);

  // const onMouseEnter = React.useCallback(() => {
  //   if (timerRef.current) {
  //     clearTimeout(timerRef.current);
  //   }
  // }, []);





  const view = React.useMemo(() => {
    return {
      agenda: { type: 'week' }
    };
  }, []);



  return (
    <div className='main'>
      <div className='flex-container'>
        <Eventcalendar
          className='agenda-calendar'
          theme="ios"
          themeVariant="light"
          locale={localeNo}
          height={'calc(100vh - 200px)'}
          data={myEvents}
          view={view}
          clickToCreate={false}
          dragToCreate={false}
          showEventTooltip={false}
          onEventClick={onEventClick}
        // onEventHoverIn={onEventHoverIn}
        // onEventHoverOut={onEventHoverOut}
        />
        {/* <Popup
          display="anchored"
          isOpen={isOpen}
          anchor={anchor}
          touchUi={false}
          showOverlay={false}
          contentPadding={false}
          closeOnOverlayClick={false}
          width={350}
          cssClass="md-tooltip"
          buttons={popupButtons}
          onClose={onClose}
        >
          <div className="mbsc-form-group">
            <div className="md-tooltip-header" style={{ backgroundColor: bgColor }}>
              <span className="md-tooltip-name-title"></span>
            </div>
            <div className="md-tooltip-info">
              <div className="md-tooltip-title">
              </div>
              <div className="md-tooltip-title">
                {array.map((item, index) => (
                  <div>
                    {console.log(item)}
                    <Checkbox disabled={true} label={item.name} defaultChecked={isChecked.includes(item.id)} onChange={() => handleResourceCheckInEvent(item)}></Checkbox>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Popup> */}
        <div className='agenda-content'>
          <div className='header'>
            <h2>User Settings</h2>
          </div>
          <div className='user-header'>
            <div className='user-content'>
              <h3>{user.displayName}</h3>
              <p>{user.email}</p>
            </div>
            <img src={userSettings?.userImage || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png'} alt="" />
          </div>
          <div>
            {equipment.map((item, index) => (
              <div>
                <div >{item.name}</div>
              </div>
            ))}
            <div className='selected-event-container'>
              {/* <h2>{currentEvent === null ? currentEvent : console.log('  no active event')}</h2> */}
              <h2 style={{ backgroundColor: currentEvent?.color }} className='selected-event-header'>{currentEvent?.title ?? 'Select an event'}</h2>
              <p style={{ backgroundColor: currentEvent?.color }} className='selected-event-desctiption'>{currentEvent?.description ?? ''}</p>
              <div className="mbsc-form-group">
                <h4>{currentEvent ? 'Crew' : ''}</h4>
                {eventContent.map(item => {
                  if (item.id < 5) {
                    return (<div className='selected-event-crew' key={item.id}>{item.name}</div>)
                  }
                  return null;
                })}
              </div>
              <div className="mbsc-form-group">
                <h4>{currentEvent ? 'Equipment' : ''}</h4>
                {eventContent.map(item => {
                  if (item.id > 5) {
                    return (<div className='selected-event-equipment' key={item.id}>{item.name}</div>)
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


}

export default Agenda